import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import { Box } from "@mui/material";
import Moment from "react-moment";
import React from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    date: {
      whiteSpace: "nowrap",
      marginRight: 3,
    },
    time: {
      fontSize: 13,
      marginLeft: 3,
      whiteSpace: "nowrap",
    },
  })
);

const DateTime = (props: any) => {
  const classes = useStyles();
  const { dateFormat, timeFormat, timeZone, dateTime } = props;

  return (
    <>
      <Box component="span" className={classes.date}>
        <Moment format={dateFormat} tz={timeZone}>
          {dateTime}
        </Moment>
      </Box>
      <Box component="span" className={classes.time}>
        <Moment format={timeFormat} tz={timeZone}>
          {dateTime}
        </Moment>
      </Box>
    </>
  );
};

export default DateTime;
